/**
 * @generated SignedSource<<ebdc08e1f2b3b9334c19f1800999fc91>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Row580BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueRow" | "useRowColor12BadPattern">;
  readonly " $fragmentType": "Row580BadPattern";
};
export type Row580BadPattern$key = {
  readonly " $data"?: Row580BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"Row580BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "Row580BadPattern",
  "selections": [
    {
      "condition": "isConditionalFormattingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "useRowColor12BadPattern"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "IssueRow"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b3e7337b0e59cbea12d107f3750014d8";

export default node;
